/*
 * WARNING : Also add the popin in the POPINS enum in the ./constants.ts file !!
 */
import dynamic from 'next/dynamic'

export const ConfirmationPopin = dynamic(() =>
  import('general/popins/ConfirmationPopin').then((m) => m.ConfirmationPopin),
)

export const ConnectPopin = dynamic(() => import('modules/auth/popins/ConnectPopin').then((m) => m.ConnectPopin))
export const LostPwdPopin = dynamic(() => import('modules/auth/popins/LostPwdPopin').then((m) => m.LostPwdPopin))
export const DoubleFaPopin = dynamic(() => import('modules/auth/popins/DoubleFaPopin').then((m) => m.DoubleFaPopin))

export const FacebookConfirmPopin = dynamic(() =>
  import('modules/auth/popins/FacebookConfirmPopin').then((m) => m.FacebookConfirmPopin),
)
export const CommunityMembersListPopin = dynamic(() =>
  import('modules/community/popins/CommunityMembersListPopin').then((m) => m.CommunityMembersListPopin),
)

export const CommunitiesPropositionsPopin = dynamic(() =>
  import('modules/community/popins/CommunitiesPropositionsPopin').then((m) => m.CommunitiesPropositionsPopin),
)

export const BroadcastIntentionWidgetPopin = dynamic(() =>
  import('modules/intention/popins/BroadcastIntentionWidgetPopin').then((m) => m.BroadcastIntentionWidgetPopin),
)

export const UserPrayPopin = dynamic(() => import('modules/pray/popins/UserPrayPopin').then((m) => m.UserPrayPopin))

export const InvitePopin = dynamic(() => import('modules/share/popins/InvitePopin').then((m) => m.InvitePopin))
export const InviteEmailPopin = dynamic(() =>
  import('modules/share/popins/InviteEmailPopin').then((m) => m.InviteEmailPopin),
)
export const WidgetPopin = dynamic(() =>
  import('modules/share/popins/WidgetPopin/WidgetPopin').then((m) => m.WidgetPopin),
)

export const PresubscriberDeletedPopin = dynamic(() =>
  import('modules/user/popins/PresubscriberDeletedPopin').then((m) => m.PresubscriberDeletedPopin),
)
